import "./index.scss";

const Footer = () => {

    return (
        <footer>
            <p>© 2025 Academia StackX. Todos os direitos reservados.</p>
        </footer>
    )
}

export default Footer;